function OffenderUnenrollment(aUserId, aEnrolleeId) {
    "use strict";

    this.__type = 'OffenderUnenrollment:www.veritracks.com';
    this.Id = aEnrolleeId;
    this.Version = 0;

    this.ReasonId = -1;
    this.UserId = aUserId;
    this.ChargerReturnStatus = '';
    this.AttemptRecoverFlag = false;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderUnenrollment;
}